'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onBlur", "onFocus"];
import PropTypes from 'prop-types';
import { forwardRef, useRef, useState } from 'react';
import { useTouchListener } from './useTouchListener';
import { jsx as _jsx } from "react/jsx-runtime";
const identity = () => {};
const withBlurHandler = WrappedComponent => {
  const Component = /*#__PURE__*/forwardRef((props, ref) => {
    const {
        onBlur: parentOnBlur,
        onFocus: parentOnFocus
      } = props,
      rest = _objectWithoutPropertiesLoose(props, _excluded);
    const _ref = useRef();
    const inputRef = ref || _ref;
    const [target, setTarget] = useState(null);
    const onTouchEvent = e => {
      if (target && e.target !== target) {
        if (inputRef.current) {
          inputRef.current.blur();
        }
        setTarget(null);
        return false;
      }
      return Boolean(target);
    };
    useTouchListener(onTouchEvent);
    const onBlur = e => {
      setTarget(null);
      parentOnBlur(e);
    };
    const onFocus = e => {
      if (e.target) {
        setTarget(e.target);
      }
      parentOnFocus(e);
    };
    return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, rest, {
      ref: inputRef,
      onFocus: onFocus,
      onBlur: onBlur
    }));
  });
  Component.propTypes = {
    onBlur: PropTypes.func,
    onFocus: PropTypes.func
  };

  /* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
  Component.defaultProps = {
    onBlur: identity,
    onFocus: identity
  };
  Component.displayName = 'Component';
  return Component;
};
withBlurHandler.propTypes = {
  onBlur: PropTypes.func.isRequired,
  onFocus: PropTypes.func.isRequired
};
export default withBlurHandler;